/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, SetStateAction, useEffect, useRef, useMemo } from 'react';
import { TooltipContentProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import { SensorMeasurement } from 'utils/constants';

const CustomTooltip = ({
  active,
  payload,
  label,
  setActiveDot,
  isFullGraph,
}: TooltipContentProps<ValueType, NameType> & {
  setActiveDot: Dispatch<SetStateAction<number | null>>;
  isFullGraph?: boolean;
}) => {
  const isVisible = active && payload && payload.length;
  const lastValueRef = useRef<number | null>(null);
  const lastActiveRef = useRef<boolean>(false);

  // Извлекаем и стабилизируем числовое значение
  const rawValue = payload?.[0]?.value;
  const valueAsNumber = typeof rawValue === 'number' && !isNaN(rawValue) && isFinite(rawValue) 
    ? rawValue 
    : null;
  
  const numericValue = useMemo(() => {
    return valueAsNumber;
  }, [valueAsNumber]);

  useEffect(() => {
    // Обновляем только если значение действительно изменилось
    if (active && numericValue !== null) {
      if (numericValue !== lastValueRef.current) {
        lastValueRef.current = numericValue;
        // Используем функциональную форму для избежания лишних обновлений
        setActiveDot((prev) => {
          // Обновляем только если значение действительно изменилось
          return prev !== numericValue ? numericValue : prev;
        });
      }
      lastActiveRef.current = true;
    } else if (!active && lastActiveRef.current) {
      // Сбрасываем значение, когда tooltip становится неактивным
      if (lastValueRef.current !== null) {
        lastValueRef.current = null;
        setActiveDot((prev) => {
          // Сбрасываем только если значение не null
          return prev !== null ? null : prev;
        });
      }
      lastActiveRef.current = false;
    }
    // Используем active и numericValue в зависимостях
    // setActiveDot не включаем, так как это стабильная функция setState
  }, [active, numericValue]);

  return (
    <div
      className="sensor-details__custom-tooltip"
      style={{ visibility: isVisible ? 'visible' : 'hidden' }}
    >
      {isVisible && (
        <>
          {payload?.map((item, key) => {
            const measurement = SensorMeasurement[item.name];
            const hasValue = item?.value != null;
            const displayValue = hasValue
              ? `${item.value}${measurement?.unit ? ` ${measurement.unit}` : ''}`
              : '-';

            return (
              <p
                key={key}
                className="sensor-details__custom-tooltip__value"
                style={{ color: item.stroke }}
              >
                {isFullGraph && measurement?.label
                  ? `${measurement.label}: ${displayValue}`
                  : displayValue}
              </p>
            );
          })}
          <p className="sensor-details__custom-tooltip__label">{label}</p>
        </>
      )}
    </div>
  );
};

export default CustomTooltip;
